import React from "react";
import {PATH} from "../../config";
import {Button} from "antd";
import {NavLink} from "react-router-dom";

const MetahutPurchase = ({paymentType, Token, updateMetahutCount, DoBuying}) => {
    return <>
            <h4 className="uppercase font-bold gland-pay_ttl">Amount</h4>
            <div className="flex items-start justify-between gap-y-4 flex-wrap gap-x-8 gland-amount_row mb-6">
                <div className="flex flex-col gap-y-1">
                    <p className="mb-0 font-normal gland-amount_token">{Token.price} {Token.name}</p>
                    {paymentType != 3 ? <span className="font-normal gland-amount_usd">≈ {Token.priceUsd} USD</span> : ''}
                </div>
                <span>x</span>
                <div className="flex gap-x-4 gland-amount_land">
                    <input
                        className="bg-white text-indigo-700 font-bold border-0 rounded-md text-center font-mont gland-amount_input"
                        type="text"
                        defaultValue="1"
                        name="landLimit"
                        onChange={(e) => updateMetahutCount(e.target.value)}
                    />
                    <div className="flex flex-col gap-y-1">
                        <p className="mb-0 font-normal gland-amount_token">Metahut</p>
                        <span className="font-normal font-mont gland-amount_limit">3 rooms</span>
                    </div>
                </div>
            </div>
            {/*<div className="discount-volume">*/}
            {/*    <div className="flex items-center gap-x-2 mb-5">*/}
            {/*        <h5 className="uppercase font-bold gland-amount_ttl" style={{marginBottom: "0"}}>discount by volume</h5>*/}
            {/*        <span className="discount-status">Claim</span>*/}
            {/*    </div>*/}
            {/*    <div className="discount-level flex flex-col gap-y-1 mb-3">*/}
            {/*        <div className="w-100 flex level-part">*/}
            {/*            <div className="discount-percent">*/}
            {/*                <span className="font-mont level-percent">0%</span>*/}
            {/*                <div className="level-y"></div>*/}
            {/*            </div>*/}
            {/*            <div className="discount-percent">*/}
            {/*                <span className="font-mont level-percent">10%</span>*/}
            {/*                <div className="level-y"></div>*/}
            {/*            </div>*/}
            {/*            <div className="discount-percent">*/}
            {/*                <span className="font-mont level-percent">20%</span>*/}
            {/*                <div className="level-y"></div>*/}
            {/*            </div>*/}
            {/*            <div className="discount-percent">*/}
            {/*                <span className="font-mont level-percent">30%</span>*/}
            {/*                <div className="level-y"></div>*/}
            {/*            </div>*/}
            {/*            <div className="discount-percent">*/}
            {/*                <span className="font-mont level-percent">40%</span>*/}
            {/*                <div className="level-y"></div>*/}
            {/*            </div>*/}
            {/*            <div>*/}
            {/*                <span className="font-mont level-percent">50%</span>*/}
            {/*                <div className="level-y"></div>*/}
            {/*            </div>*/}
            {/*            <div>*/}
            {/*                <span className="font-mont level-percent">60%</span>*/}
            {/*                <div className="level-y"></div>*/}
            {/*            </div>*/}
            {/*            <div>*/}
            {/*                <span className="font-mont level-percent">70%</span>*/}
            {/*                <div className="level-y"></div>*/}
            {/*            </div>*/}
            {/*            <div>*/}
            {/*                <span className="font-mont level-percent">80%</span>*/}
            {/*                <div className="level-y"></div>*/}
            {/*            </div>*/}
            {/*            <div>*/}
            {/*                <span className="font-mont level-percent">90%</span>*/}
            {/*                <div className="level-y"></div>*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*        <div className="w-100 flex level-line">*/}
            {/*            <div className="discount-line"></div>*/}
            {/*            <div className="discount-line"></div>*/}
            {/*            <div className="discount-line"></div>*/}
            {/*            <div className="discount-line"></div>*/}
            {/*            <div></div>*/}
            {/*            <div></div>*/}
            {/*            <div></div>*/}
            {/*            <div></div>*/}
            {/*            <div></div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="font-light discount-note mb-10">*/}
            {/*        Your volume for the current month is 25,300 USD. <NavLink to="#" className="text-cyan-400">Get more info</NavLink>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="gland-amount-total">
                <h5 className="uppercase font-bold gland-amount_ttl">Complete Amount</h5>
                <div className="flex flex-col gland-amount_price">
                    <div className="flex items-center gap-x-1 gland-amount_token">
                        {Token.nftCount ? Token.totalPrice : '-' }
                        <img src={PATH + Token.icon} style={{height: "16px", marginLeft: "3px"}} alt=""/>
                        {Token.name}
                    </div>
                    {paymentType != 3 ? <span className="gland-amount_usd">≈ {Token.totalPriceUsd + ' USD'}</span> : ''}
                </div>
                {/*{paymentType == 1 ? <p className="font-light gland-amount_discount">You're reducing your payment by {Token.discount} USD</p> : ''}*/}
            </div>
            <div className="line-x"></div>
            <p className="font-light font-sans gland-amount_note">Check that your country of citizenship allows for the purchase of cryptocurrency before proceeding.</p>
            <div className="text-center">
                <Button
                    disabled={Token.nftCount ? '' : 'disable'}
                    className={`border-0 mb-5 rounded-3xl font-normal gland-amount_btn ${Token.nftCount ? 'bg-cyan-500 text-indigo-900 hover:bg-cyan-400' : 'bg-indigo-600 text-white opacity-50 cursor-not-allowed'}`}
                    onClick={DoBuying}
                >Purchase</Button>
            </div>
        </>
}

export default MetahutPurchase;